import kebabCase from 'lodash/kebabCase';

const createSlug = (s: unknown, { maxLength }: { maxLength?: number } = {}) =>
  typeof s === 'string' ? encodeURIComponent(kebabCase(s.slice(0, maxLength).toLowerCase())) : '';

export default createSlug;
